export default "<app-admin-caja [cobros_detalle]=\"true\"></app-admin-caja>";